import { Component, OnInit } from '@angular/core';
import {GoogleChartInterface } from 'ng2-google-charts/ng2-google-charts';
import { FormControl } from '@angular/forms';
import { AppComponent } from '../app.component';




@Component({
  selector: 'app-deu',
  templateUrl: './deu.component.html',
  styleUrls: ['./deu.component.css']
})
export class DeuComponent implements OnInit {

  public selectedplace = '';

  public bancointernacional = ['Sierra/Quito/LaY', 'Sierra/Quito/MatrizP13', 'Sierra/Quito/Iñaquito', 'Sierra/Cuenca/SucursalCuenca', 'Costa/Machala/SucursalMachala', 'Costa/Guayaquil/Sonesta', 'Costa/Guayaquil/Urdesa', 'Costa/Manta/SucursalManta', 'Oriente/Coca/SucursalCoca', 'Oriente/LagoAgrio/SucursalLagoAgrio']

  public grupokfcCasaRes = ['Sierra/Quito/R012']
  public grupokfcCajun = ['Costa/Portoviejo/CJ25']

  public concesionarios = ['Sierra/Cumbaya/Autoconsa', 'Sierra/LosChillos/EcuaAuto']

  public farmaenlace = ['Sierra/Quito/OficinasFarmaenlace']

  public Places = ['Sierra/Quito/LaY', 'Sierra/Quito/MatrizP13', 'Sierra/Quito/Iñaquito', 'Sierra/Cuenca/SucursalCuenca', 'Costa/Machala/SucursalMachala', 'Costa/Guayaquil/Sonesta', 'Costa/Guayaquil/Urdesa', 'Costa/Manta/SucursalManta', 'Oriente/Coca/SucursalCoca', 'Oriente/LagoAgrio/SucursalLagoAgrio'];

  public LaYTree = [ 
    ['Phrases'], 
    ['EEQ Aire/Acondicionado'],
    ['EEQ TN TE UPS Sala Reuniones PA Gerencia PA'],
    ['EEQ TN TE UPS Lampara Emergencia'],
    ['EEQ TN TE UPS Jefe Operativo PB'],
    ['EEQ TN TE UPS Gerencia PB'],
    ['EEQ TN TE UPS Cajas#2 #3 #4 PB'],
    ['EEQ TN TE UPS Camara Pasillo PA'],
    ['EEQ TN TE UPS Oficina_PA'],
    ['EEQ TN TE UPS TV Servicio al Cliente'],
    ['EEQ TN TE UPS Servicio al cliente PB'],
    ['EEQ TN TE UPS Puerta Principal Boveda'],
    ['EEQ TN TE UPS Oficina_PB'],
    ['EEQ TN TE UPS Rack'],
    ['EEQ TN TE Tomas Pre-Boveda'],
    ['EEQ TN TE Iluminacion_Cafeteria'],
    ['EEQ TN TE Iluminacion_Cajas'],
    ['EEQ TN TE Iluminacion_Archivo'],
    ['EEQ TN TE BY-PASS UPS'],
    ['EEQ TN TE Tomas_Gerencia PA'],
    ['EEQ TN TE Asesores PB'],
    ['EEQ TN TE Cafeteria Lampara de Emergencia'],
    ['EEQ TN TE Iluminacion_Archivo Gradas Secundarias'],
    ['EEQ TN TE Iluminacion_Baños'],
    ['EEQ TN TE Iluminacion_Oficinas Baños PB'],
    ['EEQ TN TE Iluminacion_Asesores Garita'],
    ['EEQ TN TE Iluminacion_ATM Hall Cajas'],
    ['EEQ TN TE Iluminacion Servicio al Cliente'],
    ['EEQ TN TE Tomas_Servicio Cliente'],
    ['EEQ TN Tomas_Pasillo Gerencia'],
    ['EEQ TN Tomas_Baños PB'],
    ['EEQ TN Televisores PB'],
    ['EEQ TN Tomas_Oficina_PA'],
    ['EEQ TN Tomas_Gerencia_PB'],
    ['EEQ TN Inyectores Cuarto de Equipos'],
    ['EEQ TN Iluminacion_Gradas PB']
  ]
  zoomLevel = 1;
  
  src = "https://bancointernacional.appspot.com.storage.googleapis.com/DEUs/DEU-BANINTER-MACHALA-DEU.pdf";
  public LaYURL = 'https://bancointernacional.appspot.com.storage.googleapis.com/DEUs/DEU-BANINTER-LaY%2023-11-20-DEU.pdf'
  
  public MachalaURL = 'https://bancointernacional.appspot.com.storage.googleapis.com/DEUs/DEU-BANINTER-MACHALA-DEU.pdf'
  public MachalaTree = [
    ['Phrases'], 
    ['CNEL TN'],
    ['CNEL TTA TE Iluminacion_Hall_Cajas'],
    ['CNEL TTA TE Iluminacion_Hall_Cajas y Acceso'],
    ['CNEL TTA TE Iluminacion_Asesores'],
    ['CNEL TTA TE Iluminacion_Cocina'],
    ['CNEL TTA TE Iluminacion_Archivo Limpieza'],
    ['CNEL TTA TE Iluminacion_Sala_de_Reuniones'],
    ['CNEL TTA TE Lampara_de_Emergencia_Izquierda'],
    ['CNEL TTA TE Lampara_de_Emergencia_Derecha'],
    ['CNEL TTA TE Timer#1 totem y postes'],
    ['CNEL TTA TE Timer#2 Cinta LED'],
    ['CNEL TTA TE Timer#3 Letrero Logotipo'],
    ['CNEL TTA TE Timer#4 Jardinera'],
    ['CNEL TTA TE Timer#5 Reflectores Lucesparqueo'],
    ['CNEL TTA TE Tomacorrientes_Cajas'],
    ['CNEL TTA TE Tomacorrientes_Impresoras'],
    ['CNEL TTA TE Impresora_Asesor de Servicios'],
    ['CNEL TTA TE Impresora_AsesorComercial'],
    ['CNEL TTA TE Tomacorrientes_Asesores Comerciales'],
    ['CNEL TTA TE Tomacorrientes_Contadoras Cajas'],
    ['CNEL TTA TE Tomacorrientes pre-boveda'],
    ['CNEL TTA TE Tomacorriente_Sala de Reuniones'],
    ['CNEL TTA TE Tomacorrientes_Asesor de Servicio'],
    ['CNEL TTA TE Refrigerador'],
    ['CNEL TTA TE SplitAire Cuarto Rack'],
    ['CNEL TTA TE Split ATM'],
    ['CNEL TTA TE Condensadora Aire Acondicionado Cajas 60kbtu'],
    ['CNEL TTA TE Evaporadora Aire Acondicionado Cajas 60kbtu'],
    ['CNEL TTA TE Bomba de Agua'],
    ['CNEL TTA TE Bypass UPS'],
    ['CNEL TTA TE TBypass'],
    ['CNEL TTA TE TBypass TR Tomacorrientes_Asesores_Servicio TV'],
    ['CNEL TTA TE TBypass TR Tomacorrientes_Cajas'],
    ['CNEL TTA TE TBypass TR Tomacorrientes_Jefe_Operativo'],
    ['CNEL TTA TE TBypass TR Tomacorrientes_Gerencia pre-boveda'],
    ['CNEL TTA TE TBypass TR Tomacorrientes_Asesores_Comerciales'],
    ['CNEL TTA TE TBypass TR Tomacorrientes_Sala de reuniones_TV'],
    ['CNEL TTA TE TBypass TR Camaras_Boveda Rack Cocina'],
    ['CNEL TTA TE TBypass TR Camaras_Asesores_Servicio Cajas'],
    ['CNEL TTA TE TBypass TR Camaras Hal ATM'],
    ['CNEL TTA TE TBypass TR Camaras_Exteriores'],
    ['CNEL TTA TE TBypass TR Camaras_Pingol ATM'],
    ['CNEL TTA TE TBypass TR Tomacorrientes_ATM telefono Kiosko'],
    ['CNEL TTA TE TBypass TR Tomacorrientes_Torsion_DVR'],
    ['CNEL TTA TE TBypass TR Tomacorrientes_Torsion_Rack'],
    ['CNEL TTA TE TBypass TR Tomacorrientes_tablero de seguridad-boveda'],
    ['CNEL TTA TE TBypass TR Tomacorrientes_tablero_seguridad-boveda'],
    ['CNEL TTA TE TBypass TR Tomacorrientes_para alta cuarto Rack'],
  ]

  public SonestaURL = 'https://bancointernacional.appspot.com.storage.googleapis.com/DEUs/DEU-BANINTER-SONESTA-DEU.pdf'
  public SonestaTree = [
    ['Phrases'], 
    ['CNEL #1 AA/PB'],
    ['CNEL #2 -'],
    ['CNEL #3 TN Condensador A/A #1'],
    ['CNEL #3 TN Evaporador A/A #1'],
    ['CNEL #3 TN Cuarto de Rack'],
    ['CNEL #3 TN Cafeteria'],
    ['CNEL #4 TTA'],
    ['CNEL #4 TTA TE Iluminacion_Hall_Cajas'],
    ['CNEL #4 TTA TE Iluminacion_Gerente_Hall_Ingreso'],
    ['CNEL #4 TTA TE Iluminacion_ATM'],
    ['CNEL #4 TTA TE Iluminacion_Recuento'],
    ['CNEL #4 TTA TE Tomas_Servicio_Cliente'],
    ['CNEL #4 TTA TE Iluminacion_Hall_pasillo#2'],
    ['CNEL #4 TTA TE Lamparas_Emergencia_Conteo'],
    ['CNEL #4 TTA TE Rotulos_Exteriores_Posteriores'],
    ['CNEL #4 TTA TE Tomacorrientes_Reconteo'],
    ['CNEL #4 TTA TE Tomacorrientes_Cajas_Conteo'],
    ['CNEL #4 TTA TE Tomacorrientes_ATM'],
    ['CNEL #4 TTA TE Tomacorrientes_Gerencia_Negocios'],
    ['CNEL #4 TTA TE Tomacorrientes_Cajas_Jefe_Operativo'],
    ['CNEL #4 TTA TE Iluminacion_PA'],
    ['CNEL #4 TTA TE Iluminacion_Hall_Posterior'],
    ['CNEL #4 TTA TE Luces_Hall_Servicio_al_Cliente'],
    ['CNEL #4 TTA TE Baño y Archivo'],
    ['CNEL #4 TTA TE Rotulo_Cajero_Posterior'],
    ['CNEL #4 TTA TR Camaras_Pre-boveda_Ingreso_exterior'],
    ['CNEL #4 TTA TR Tomacorrientes_Conteo_Asesores'],
    ['CNEL #4 TTA TR Camaras_Caja#5_#6_Tomas_Cajas_Seguridad'],
    ['CNEL #4 TTA TR Timer_Luces#1'],
    ['CNEL #4 TTA TR Rack'],
    ['CNEL #4 TTA TR TV_Camara_frente_cajas'],
    ['CNEL #4 TTA TR Tomas_Cajas_Jefe_Operativo'],
    ['CNEL #4 TTA TR Camaras_ATM'],
    ['CNEL #4 TTA TR Tomas_ATM_CAMARA_ATM_FACIAL'],
    ['CNEL #4 TTA TR Tomas_Gerente_Asesor_Negocios'],
    ['CNEL #4 TTA TR Tomas_Gerencia_Negocios_Camara_Gerencia'],
    ['CNEL #4 TTA TR Camara_Cuarto_Equipos'],
    ['CNEL #4 TTA TR Ingreso_Telefono_AutoServicio_Camara_ATM'],
    ['CNEL #4 TTA TR Camara_operativo_Sonesta'],
    ['CNEL #4 TTA TR Operativo_Camara_Balcon_ATM_Sonesta'],

  ]

  public MantaURL = 'https://bancointernacional.appspot.com.storage.googleapis.com/DEUs/DEU-BANINTER-MANTA-DEU.pdf'

  public CocaURL = 'https://bancointernacional.appspot.com.storage.googleapis.com/DEUs/DEU-BANINTER-COCA-DEU.pdf'

  public UrdesaURL = 'https://bancointernacional.appspot.com.storage.googleapis.com/DEUs/DEU-BANINTER-URDENSA-DEU.pdf'

  public CuencaURL = 'https://bancointernacional.appspot.com.storage.googleapis.com/DEUs/DEU-BANINTER-CUENCA-DEU.pdf'

  public LagoAgrioURL = 'https://bancointernacional.appspot.com.storage.googleapis.com/DEUs/DEU-BANINTER-LAGOAGRIO-DEU.pdf'

  public MatrizP13URL = 'https://bancointernacional.appspot.com.storage.googleapis.com/DEUs/DEU-BAINTER-MATRIZ%20P13-DEU.pdf'

  public InaquitoURL = 'https://bancointernacional.appspot.com.storage.googleapis.com/DEUs/DEU-BAINTER-INAQUITO-DEU.pdf'

  public R012URL = 'https://grupokfc-casa-res.appspot.com.storage.googleapis.com/DEUs/DEU-CASA-RES-CONDADO.pdf'
  public R012Tree = [
    ['Phrases'],
    ['EEQ Medidor#1 Tablero#1 Tomas-Cajas#1'],
    ['EEQ Medidor#1 Tablero#1 CalentadorPapas'],
    ['EEQ Medidor#1 Tablero#1 Módulo Caliente'],
    ['EEQ Medidor#1 Tablero#1 Licuadora#1'],
    ['EEQ Medidor#1 Tablero#1 Tomas-Clientes-Salón'],
    ['EEQ Medidor#1 Tablero#1 Máquina de Café'],
    ['EEQ Medidor#1 Tablero#1 Licuadora#2'],
    ['EEQ Medidor#1 Tablero#1 Licuadora#3'],
    ['EEQ Medidor#1 Tablero#1 Robot Coupe'],
    ['EEQ Medidor#1 Tablero#1 Audio y Video'],
    ['EEQ Medidor#1 Tablero#1 Freidora'],
    ['EEQ Medidor#1 Tablero#1 Timer Fritura'],
    ['EEQ Medidor#1 Tablero#1 Estación-Pedidos-PB'],
    ['EEQ Medidor#1 Tablero#1 Campana de Extracción'],
    ['EEQ Medidor#1 Tablero#1 Lavavajillas'],
    ['EEQ Medidor#1 Tablero#1 Oficina / Rack'],
    ['EEQ Medidor#1 Tablero#1 Tomas-Clientes-PB'],
    ['EEQ Medidor#1 Tablero#1 Estación-Pedidos-MZZ'],
    ['EEQ Medidor#1 Tablero#1 BypassUPS'],
    ['EEQ Medidor#1 Tablero#1 BypassUPS'],
    ['EEQ Medidor#1 Tablero#1 BypassUPS Monitor de Comandas/Impresora'],
    ['EEQ Medidor#1 Tablero#1 Freidora de Huevos'],
    ['EEQ Medidor#1 Tablero#1 Molino de Café'],
    ['EEQ Medidor#2 Tablero#2 Máquina de Colas'],
    ['EEQ Medidor#2 Tablero#2 Postmix'],
    ['EEQ Medidor#2 Tablero#2 Refri Undercounter'],
    ['EEQ Medidor#2 Tablero#2 Maq Hielos Grande'],
    ['EEQ Medidor#2 Tablero#2 Refri-Horizontal True'],
    ['EEQ Medidor#2 Tablero#2 Refri-Undercounter#2'],
    ['EEQ Medidor#2 Tablero#2 Congelador Underc Bebidas'],
    ['EEQ Medidor#2 Tablero#2 Mesa Fría Lateral'],
    ['EEQ Medidor#2 Tablero#2 Cuarto-Refrigeración'],
    ['EEQ Medidor#2 Tablero#2 Cuarto-Congelación'],
    ['EEQ Medidor#2 Tablero#2 Base Refrigerada Parrilla'],
    ['EEQ Medidor#2 Tablero#2 Mesa-Refri Bajo Counter'],
    ['EEQ Medidor#2 Tablero#2 Refri-Ensaladas-MZZ'],
    ['EEQ Medidor#2 Tablero#2 Refri-Ensaladas-PB'],
    ['EEQ Medidor#2 Tablero#2 Refri-Bajo Counter Beb'],
    ['EEQ Medidor#2 Tablero#3 Rótulos Fachada'],
  ]

  public CJ25URL = 'https://grupokfc-casa-res.appspot.com.storage.googleapis.com/DEUs/DEU-CAJUN-PORTOVIEJO-CJ25-DEU.pdf';

  public FarmaenlaceOficinasURL = 'https://grupokfc-casa-res.appspot.com.storage.googleapis.com/DEUs/Unifilar%20Farmaenlace%20GVC.pdf'

  public VerisComiteURL = 'https://storage.googleapis.com/bancointernacional.appspot.com/DEUs/DEU-01%20PMF%20COMITE%CC%81%20DEL%20PUEBLO-DEU.pdf'//'https://veris-gentec.appspot.com.storage.googleapis.com/DEUs/DEU-01%20PMF%20COMITE%CC%81%20DEL%20PUEBLO-DEU.pdf'
  public verisGentec = ['Sierra/Quito/PMFComité']

   public EmptyTree = [
    ['Phrases']
  ]

  public treeMap: GoogleChartInterface = {
    chartType: 'WordTree',
    dataTable: [ 
      ['Phrases'], 
      ['EEQ Aire/Acondicionado'],
      ['EEQ TN TE UPS Sala Reuniones PA Gerencia PA'],
      ['EEQ TN TE UPS Lampara Emergencia'],
      ['EEQ TN TE UPS Jefe Operativo PB'],
      ['EEQ TN TE UPS Gerencia PB'],
      ['EEQ TN TE UPS Cajas#2 #3 #4 PB'],
      ['EEQ TN TE UPS Camara Pasillo PA'],
      ['EEQ TN TE UPS Oficina_PA'],
      ['EEQ TN TE UPS TV Servicio al Cliente'],
      ['EEQ TN TE UPS Servicio al cliente PB'],
      ['EEQ TN TE UPS Puerta Principal Boveda'],
      ['EEQ TN TE UPS Oficina_PB'],
      ['EEQ TN TE UPS Rack'],
      ['EEQ TN TE Tomas Pre-Boveda'],
      ['EEQ TN TE Iluminacion_Cafeteria'],
      ['EEQ TN TE Iluminacion_Cajas'],
      ['EEQ TN TE Iluminacion_Archivo'],
      ['EEQ TN TE BY-PASS UPS'],
      ['EEQ TN TE Tomas_Gerencia PA'],
      ['EEQ TN TE Asesores PB'],
      ['EEQ TN TE Cafeteria Lampara de Emergencia'],
      ['EEQ TN TE Iluminacion_Archivo Gradas Secundarias'],
      ['EEQ TN TE Iluminacion_Baños'],
      ['EEQ TN TE Iluminacion_Oficinas Baños PB'],
      ['EEQ TN TE Iluminacion_Asesores Garita'],
      ['EEQ TN TE Iluminacion_ATM Hall Cajas'],
      ['EEQ TN TE Iluminacion Servicio al Cliente'],
      ['EEQ TN TE Tomas_Servicio Cliente'],
      ['EEQ TN Tomas_Pasillo Gerencia'],
      ['EEQ TN Tomas_Baños PB'],
      ['EEQ TN Televisores PB'],
      ['EEQ TN Tomas_Oficina_PA'],
      ['EEQ TN Tomas_Gerencia_PB'],
      ['EEQ TN Inyectores Cuarto de Equipos'],
      ['EEQ TN Iluminacion_Gradas PB']
    ],

    
    // ['EEQ Aire/Acondicionado'],
    // ['EEQ TN TE UPS Sala Reuniones PA Gerencia PA'],
    // ['EEQ TN TE UPS Lampara Emergencia'],
    // ['EEQ TN TE UPS Jefe Operativo PB'],
    // ['EEQ TN TE UPS Gerencia PB'],
    // ['EEQ TN TE UPS Cajas#2 #3 #4 PB'],
    // ['EEQ TN TE UPS Camara Pasillo PA'],
    // ['EEQ TN TE UPS Oficina_PA'],
    // ['EEQ TN TE UPS TV Servicio al Cliente'],
    // ['EEQ TN TE UPS Servicio al cliente PB'],
    // ['EEQ TN TE UPS Puerta Principal Boveda'],
    // ['EEQ TN TE UPS Oficina_PB'],
    // ['EEQ TN TE UPS Rack'],
    // ['EEQ TN TE Tomas Pre-Boveda'],
    // ['EEQ TN TE Iluminacion_Cafeteria'],
    // ['EEQ TN TE Iluminacion_Cajas'],
    // ['EEQ TN TE Iluminacion_Archivo'],
    // ['EEQ TN TE BY-PASS UPS'],
    // ['EEQ TN TE Tomas_Gerencia PA'],
    // ['EEQ TN TE Asesores PB'],
    // ['EEQ TN TE Cafeteria Lampara de Emergencia'],
    // ['EEQ TN TE Iluminacion_Archivo_Gradas Secundarias']
    // ['EEQ TN TE Iluminacion_Baños'],
    // ['EEQ TN TE Iluminacion_Oficinas_Baños'],
    // ['EEQ TN TE Iluminacion_Asesores Garita'],
    // ['EEQ TN TE Iluminacion_ATM Hall Cajas'],
    // ['EEQ TN TE Iluminacion Servicio al Cliente'],
    // ['EEQ TN TE Tomas_Servicio Cliente'],
    // ['EEQ TN Tomas_Pasillo Gerencia'],
    // ['EEQ TN Tomas_Baños PB'],
    // ['EEQ TN Televisores PB'],
    // ['EEQ TN Tomas_Oficina_PA'],
    // ['EEQ TN Tomas_Gerencia_PB'],
    // ['EEQ TN Inyectores Cuarto de Equipos'],
    // ['EEQ TN Iluminacion_Gradas PB']
    options: {
      wordtree: {
        format: 'implicit',
        word: 'EEQ'
      },
      tooltip : {
        isHtml: false,
        trigger: 'none',
      },
      enableInteractivity: false,
    }    
  }
  public placesControl = new FormControl();

  constructor(private app: AppComponent) { }

  ngOnInit(){
    console.log(this.app.ProjectSelected);
    if(this.app.ProjectSelected == 'Banco Internacional')
    {
      this.Places = this.bancointernacional;
      this.src = this.LaYURL;
      this.placesControl.setValue('Sierra/Quito/LaY')
      this.delay(500).then(any =>{
        this.placesControl.updateValueAndValidity()
      })
      
    }
    else if(this.app.ProjectSelected == 'Grupo KFC - Casa Res')
    {
      this.Places = this.grupokfcCasaRes;
      this.src = this.R012URL;
      this.placesControl.setValue('Sierra/Quito/R012')
      this.delay(500).then(any =>{
        this.placesControl.updateValueAndValidity()
      })
    }
    else if(this.app.ProjectSelected == 'Farmaenlace')
    {
      this.Places = this.farmaenlace;
      this.src = this.FarmaenlaceOficinasURL;
      this.placesControl.setValue('Sierra/Quito/OficinasFarmaenlace')
      this.delay(500).then(any =>{
        this.placesControl.updateValueAndValidity()
      })
    }
    else if(this.app.ProjectSelected == 'Grupo KFC - Cajun')
    {
      this.Places = this.grupokfcCajun;
      this.src = this.CJ25URL;
      this.placesControl.setValue('Costa/Portoviejo/CJ25')
      this.delay(500).then(any =>{
        this.placesControl.updateValueAndValidity()
      })
    }
    else if(this.app.ProjectSelected == 'ParaMí.')
    {
      this.Places = this.verisGentec;
      this.src = this.VerisComiteURL;
      this.placesControl.setValue('Sierra/Quito/PMFComité')
      this.delay(500).then(any =>{
        this.placesControl.updateValueAndValidity()
      })
    }
    else
    {
      this.Places = [];
      this.src = '';
    }

    this.delay(50).then(any =>{
      document.getElementById('ad').className = 'nav-options mat-button selected'
    })

  }

  change(){
    this.delay(100).then(any =>{
      if(this.placesControl.value == 'Sierra/Quito/LaY')
      {
        this.src = this.LaYURL;
      }
      if(this.placesControl.value == 'Costa/Guayaquil/Sonesta')
      {
        this.src = this.SonestaURL;
      }
      if(this.placesControl.value == 'Costa/Guayaquil/Urdesa')
      {
        this.src = this.UrdesaURL;
      }
      if(this.placesControl.value == 'Costa/Machala/SucursalMachala')
      {
        this.src = this.MachalaURL;
      }
      if(this.placesControl.value == 'Costa/Manta/SucursalManta')
      {
        this.src = this.MantaURL;
      }
      if(this.placesControl.value == 'Oriente/Coca/SucursalCoca')
      {
        this.src = this.CocaURL;
      }      
      if(this.placesControl.value == 'Sierra/Quito/R012')
      {
        this.src = this.R012URL;
      }
      if(this.placesControl.value == 'Sierra/Quito/MatrizP13')
      {
        this.src = this.MatrizP13URL;
      }
      if(this.placesControl.value == 'Oriente/LagoAgrio/SucursalLagoAgrio')
      {
        this.src = this.LagoAgrioURL;
      }
      if(this.placesControl.value == 'Sierra/Cuenca/SucursalCuenca')
      {
        this.src = this.CuencaURL;
      }
      if(this.placesControl.value == 'Sierra/Quito/Iñaquito')
      {
        this.src = this.InaquitoURL;
      }
    })
  }

  increaseZoom(){
    this.zoomLevel += 0.1;
  }
  
  decreaseZoom(){
    this.zoomLevel -= 0.1;
  }

  //delay
  async delay(ms: number) {
    await new Promise<void>(resolve => setTimeout(()=>resolve(), ms)).then(()=>console.log("delay ", ms));
  }

}
